/** @jsxImportSource @emotion/react */
import { useState } from 'react'

import { Button, Card } from 'react-bootstrap'
import { useLabPermission } from 'hooks/useLabPermission'
import { UserPermission } from 'components/lab/user/permissions'

import { QuickSightEmbed } from './QuickSightEmbed'

export const Analytics = () => {
  const canView = useLabPermission(UserPermission.VIEW_ANALYTICS)
  const [dashboardId, setDashboardId] = useState<string>('ce7df084-4a25-492e-be29-d09d717d06de')

  if (!canView) {
    return (
      <div className="container-fluid">
        <Card className="mt-3 border-0 shadow-sm">
          <Card.Body className="text-center text-muted py-5">
            <i className="fas fa-lock fa-3x mb-3" css={{ opacity: 0.3 }} />
            <p className="mb-0">You do not have access to analytics.</p>
          </Card.Body>
        </Card>
      </div>
    )
  }

  return (
    <div css={{ height: '100vh' }}>
      <div className="d-flex justify-content-center align-items-center">
        <Button
          className="mr-2"
          onClick={() => setDashboardId('ce7df084-4a25-492e-be29-d09d717d06de')}>
          Office Orders Analysis
        </Button>
        <Button
          className="mr-2"
          onClick={() => setDashboardId('9ea960bf-2320-482a-a7e0-f132c22df35a')}>
          Site Overview Dashboard
        </Button>
        <Button onClick={() => setDashboardId('9d39526b-c17c-4099-859d-e341ca320f68')}>
          Referring Physician Analysis
        </Button>
      </div>

      <QuickSightEmbed dashboardId={dashboardId} />
    </div>
  )
}

export default Analytics
